/**
 * Theo loại xuất kho
 */
export default {
  // Giấy đề nghị xuất kho
  RequestOutwardStock: 0,
  // Lệnh xuất
  OrderOutwardStock: 1
};
